import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  ProfessionalInfoContainer,
  DashboardAccountCLABEButton,
  DashboardAccountCLABETable
} from './bankInfo.styles';
import ModalRegisterCLABE from 'src/components/shared/modals/registerCLABEApplicant/registerCLABE';

export default function BankInfo({ bankInformation, personalInformation }) {
  const [registerCLABE, setRegisterCLABE] = useState(false);
  const [bankData, setBankData] = useState([]);
  const [isEditable, setIsEditable] = useState(false);
  const user = useSelector((state) => state.user.currentUser);
  const [refreshKey, setRefreshKey] = useState(0);
  const setStatus = (status) => {
    switch (status) {
      case 'inProgress':
        return 'En progreso';
      case 'rejected':
        return 'Rechazada';
      case 'approved':
        return 'Aprobada';
      default:
        return status;
    }
  };
  const handleEditClick = () => {
    setIsEditable(!isEditable);
  };

  const handleCheckboxChange = (index) => {
    setBankData((oldBankData) =>
      oldBankData.map((bank, idx) => {
        if (idx === index) {
          return {
            ...bank,
            isMainAccount: !bank.isMainAccount
          };
        } else if (bank.isMainAccount) {
          return {
            ...bank,
            isMainAccount: false
          };
        }
        return bank;
      })
    );
  };
  useEffect(() => {
    if (
      bankInformation &&
      bankInformation?.data?.getApplicant &&
      bankInformation?.data?.getApplicant?.banks
    ) {
      setBankData(bankInformation.data.getApplicant.banks.items);
    }
  }, [bankInformation]);
  const closeModal = () => {
    setRegisterCLABE(false);
    setRefreshKey((oldKey) => oldKey + 1);
  };

  const openModal = () => {
    setRegisterCLABE(true);
  };
  return (
    <ProfessionalInfoContainer>
      <ModalRegisterCLABE
        showModalRegisterCLABE={registerCLABE}
        closeModal={closeModal}
        bankData={bankData}
        personalInformation={personalInformation}
      />
      <DashboardAccountCLABEButton>
        <button onClick={openModal}>Dar de alta una nueva CLABE</button>
      </DashboardAccountCLABEButton>
      <DashboardAccountCLABETable>
        <tbody>
          <tr>
            <th>Nombre</th>
            <th>Banco</th>
            <th>CLABE</th>
            <th>Cuenta Activa</th>
            <th>
              Cuenta principal{' '}
              <button onClick={handleEditClick}>{isEditable ? 'Aceptar' : 'Editar'}</button>
            </th>
          </tr>
          {bankData.map((bank, index) => (
            <tr key={index}>
              <td>{bank.identifier}</td>
              <td>{bank.bankName}</td>
              <td>{bank.CLABE}</td>
              <td>{setStatus(bank.status)}</td>
              <td>
                {isEditable ? (
                  <input
                    type="checkbox"
                    checked={bank.isMainAccount}
                    onChange={() => handleCheckboxChange(index)}
                  />
                ) : bank.isMainAccount ? (
                  'Sí'
                ) : (
                  'No'
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </DashboardAccountCLABETable>
    </ProfessionalInfoContainer>
  );
}
